import { OPERATION_UPDATED, subscribeToMessageBus } from "common/ins-message-bus";
import { parseEnum } from "common/enum-helpers";
import { AuxNotificationStyleEnum, AuxNotificationToastTypeEnum } from "@blk/aladdin-web-components";
import { addNotification } from "store/notification";
import { language } from "language/default";
import { setDocumentResourceId, setDocumentStatus } from "./index";
import { DocumentUploadState } from "./types";
import { notesApi } from "./api";
const DOCUMENT_CANCEL_TIMEOUT_MS = 60000;
const cancelledDocumentIds = new Set();
export const markDocumentAsCancelled = (documentId) => {
    cancelledDocumentIds.add(documentId);
    setTimeout(() => cancelledDocumentIds.delete(documentId), DOCUMENT_CANCEL_TIMEOUT_MS);
};
const dispatchUploadToast = (message, style, toastType) => addNotification({
    id: Date.now().toString(),
    message,
    notificationStyle: style,
    showMessageCount: false,
    toastTimeout: 3000,
    toastType
});
const getActionsForStatus = (documentId, documentStatus, documentName, resourceId) => {
    if (documentStatus === DocumentUploadState.FILE_UPLOAD_STATUS_FAILED) {
        return [
            notesApi.endpoints.deleteDocument.initiate({ documentId }),
            dispatchUploadToast(language.en.notes.documents.uploadFailed(documentName), AuxNotificationStyleEnum.ERROR, AuxNotificationToastTypeEnum.PERSISTENT)
        ];
    }
    const actions = [setDocumentStatus({ documentId, status: documentStatus })];
    if (resourceId) {
        actions.push(setDocumentResourceId({ documentId, resourceId }));
    }
    if (documentStatus === DocumentUploadState.FILE_UPLOAD_STATUS_READY) {
        actions.push(dispatchUploadToast(language.en.notes.documents.uploadSuccess(documentName), AuxNotificationStyleEnum.SUCCESS, AuxNotificationToastTypeEnum.TIMEOUT));
    }
    return actions;
};
const parseOutputValues = (output) => {
    if (!output) {
        return null;
    }
    if (output.Values && typeof output.Values === "string") {
        try {
            const parsedOnce = JSON.parse(output.Values);
            if (typeof parsedOnce === "string") {
                return JSON.parse(parsedOnce);
            }
            return parsedOnce;
        }
        catch {
            return null;
        }
    }
    return output;
};
const parseDocumentStatus = (rawStatus) => {
    if (typeof rawStatus === "number") {
        const statusValues = Object.values(DocumentUploadState);
        return statusValues[rawStatus];
    }
    if (typeof rawStatus === "string") {
        const cleanedStatus = rawStatus.replace(/(?:^")|(?:"$)/gu, "");
        return parseEnum(DocumentUploadState, cleanedStatus);
    }
    return undefined;
};
export const reactToDocumentOperationUpdated = (message) => {
    if (message?.action !== "UploadDocuments") {
        return { actions: [] };
    }
    const documentId = Number(message?.input?.documentId);
    if (cancelledDocumentIds.has(documentId)) {
        cancelledDocumentIds.delete(documentId);
        return { actions: [] };
    }
    const parsedOutput = parseOutputValues(message?.output);
    const rawStatus = parsedOutput?.status;
    const rawResourceId = parsedOutput?.resourceId;
    const documentStatus = parseDocumentStatus(rawStatus);
    const resourceId = typeof rawResourceId === "string"
        ? rawResourceId.replace(/(?:^")|(?:"$)/gu, "")
        : undefined;
    if (!documentId || documentStatus === undefined) {
        return { actions: [] };
    }
    return {
        actions: getActionsForStatus(documentId, documentStatus, message?.input?.fileName, resourceId),
        callback: parsedOutput ? () => { } : undefined
    };
};
export const notesSubscriptions = () => {
    subscribeToMessageBus(OPERATION_UPDATED, reactToDocumentOperationUpdated);
};
